module.exports = __webpack_public_path__ + "media/img/calendar/change-bda8c92ee90ec2ad8ff50f017028946e.png";